import { render } from "./BaseTextarea.vue?vue&type=template&id=7ffc39e3&scoped=true"
import script from "./BaseTextarea.vue?vue&type=script&lang=ts"
export * from "./BaseTextarea.vue?vue&type=script&lang=ts"

import "./BaseTextarea.vue?vue&type=style&index=0&id=7ffc39e3&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7ffc39e3"

export default script